<div class="sign-up-modal">
  <app-register-form (close$)="onClose($event)"></app-register-form>
</div>
